import { get, post } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

const GET_PORTFOLIO_REQUEST = 'GET_PORTFOLIO_REQUEST';
const GET_PORTFOLIO_SUCCESS = 'GET_PORTFOLIO_SUCCESS';
const GET_PORTFOLIO_ERROR = 'GET_PORTFOLIO_ERROR';

const ADD_PROPERTY_TO_PORTFOLIO_REQUEST = 'ADD_PROPERTY_TO_PORTFOLIO_REQUEST';
const ADD_PROPERTY_TO_PORTFOLIO_SUCCESS = 'ADD_PROPERTY_TO_PORTFOLIO_SUCCESS';
const ADD_PROPERTY_TO_PORTFOLIO_ERROR = 'ADD_PROPERTY_TO_PORTFOLIO_ERROR';

const GET_IS_PROPERTY_IN_PORTFOLIO_REQUEST =
	'GET_IS_PROPERTY_IN_PORTFOLIO_REQUEST';
const GET_IS_PROPERTY_IN_PORTFOLIO_SUCCESS =
	'GET_IS_PROPERTY_IN_PORTFOLIO_SUCCESS';
const GET_IS_PROPERTY_IN_PORTFOLIO_ERROR = 'GET_IS_PROPERTY_IN_PORTFOLIO_ERROR';

const initialState = {
	portfolioData: null,
	isLoading: false,
	isLoadingIsPropertyInPortfolio: false,
	error: null,
	propertyInPortfolio: null, //will be propertyId if in portfolio
};

export const getIsPropertyInPortfolio =
	(propertyId) => (dispatch, getState) => {
		let state = getState();
		let url = `${API_URL}/api/portfolios/property/${propertyId}`;
		dispatch(getIsPropertyInPortfolioRequest());

		//a successful api response means the property is in the portfolio
		//an api error means the property is not in the portfolio
		return get({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				return dispatch(getIsPropertyInPortfolioSuccess(result));
			},
			onError: () => {
				return dispatch(getIsPropertyInPortfolioError());
			},
		});
	};

export const fetchPortfolio =
	(userId, sort = 'address|asc', page = 1, perPage = 10) =>
	(dispatch, getState) => {
		let state = getState();
		let url = `${API_URL}/api/portfolio/${userId}?sort=${sort}&page=${page}&per_page=${perPage}`;
		dispatch(getPortfolioRequest());
		return get({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				return dispatch(getPortfolioSuccess(result));
			},
			onError: (error) => dispatch(getPortfolioError(error)),
		});
	};

export const addPropertyToPortfolio = (propertyId) => (dispatch, getState) => {
	let state = getState();
	let url = `${API_URL}/api/portfolios`;
	dispatch(addPropertyToPortfolioRequest());
	return post({
		dispatch,
		url,
		authToken: state.user.authToken,
		data: {
			property: {
				id: propertyId,
			},
		},
		onSuccess: (result) => {
			dispatch(addPropertyToPortfolioSuccess(result));
		},
		onError: (error) => dispatch(addPropertyToPortfolioError(error)),
	});
};

export const getPortfolioRequest = () => ({
	type: GET_PORTFOLIO_REQUEST,
	payload: {
		isLoading: true,
		portfolioData: null,
	},
});

export const getPortfolioSuccess = (data) => ({
	type: GET_PORTFOLIO_SUCCESS,
	payload: {
		isLoading: false,
		portfolioData: data,
		error: null,
	},
});

export const getPortfolioError = (error) => ({
	type: GET_PORTFOLIO_ERROR,
	payload: {
		isLoading: false,
		portfolioData: null,
		error: error,
	},
});

export const getIsPropertyInPortfolioRequest = () => ({
	type: GET_IS_PROPERTY_IN_PORTFOLIO_REQUEST,
	payload: {
		isLoadingIsPropertyInPortfolio: true,
		propertyInPortfolio: null,
	},
});

export const getIsPropertyInPortfolioSuccess = (property) => ({
	type: GET_IS_PROPERTY_IN_PORTFOLIO_SUCCESS,
	payload: {
		isLoadingIsPropertyInPortfolio: false,
		isPropertyInPortfolio: property.id,
		propertyInPortfolio: property,
	},
});

//error is the expected api response saying that the property isn't in the portfolio
export const getIsPropertyInPortfolioError = () => ({
	type: GET_IS_PROPERTY_IN_PORTFOLIO_ERROR,
	payload: {
		isLoadingIsPropertyInPortfolio: false,
		propertyInPortfolio: null,
	},
});

export const addPropertyToPortfolioRequest = () => ({
	type: ADD_PROPERTY_TO_PORTFOLIO_REQUEST,
	payload: {
		isLoading: true,
		// portfolioData: null,
	},
});

export const addPropertyToPortfolioSuccess = (data) => ({
	type: ADD_PROPERTY_TO_PORTFOLIO_SUCCESS,
	payload: {
		isLoading: false,
		// portfolioData: data,
		error: null,
	},
});

export const addPropertyToPortfolioError = (error) => ({
	type: ADD_PROPERTY_TO_PORTFOLIO_ERROR,
	payload: {
		isLoading: false,
		// portfolioData: null,
		error: error,
	},
});

const portfolioReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_PORTFOLIO_REQUEST:
		case GET_PORTFOLIO_SUCCESS:
		case GET_PORTFOLIO_ERROR:
		case GET_IS_PROPERTY_IN_PORTFOLIO_REQUEST:
		case GET_IS_PROPERTY_IN_PORTFOLIO_SUCCESS:
		case GET_IS_PROPERTY_IN_PORTFOLIO_ERROR:
		case ADD_PROPERTY_TO_PORTFOLIO_REQUEST:
		case ADD_PROPERTY_TO_PORTFOLIO_SUCCESS:
		case ADD_PROPERTY_TO_PORTFOLIO_ERROR:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default portfolioReducer;
